/**
 * @generated SignedSource<<503c77f78316babe379aff07fb57a84e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSetUserEmailNotificationsEnabledMutation_user$data = {
  readonly rowId: any;
  readonly " $fragmentType": "useSetUserEmailNotificationsEnabledMutation_user";
};
export type useSetUserEmailNotificationsEnabledMutation_user$key = {
  readonly " $data"?: useSetUserEmailNotificationsEnabledMutation_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSetUserEmailNotificationsEnabledMutation_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSetUserEmailNotificationsEnabledMutation_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5ac121798b7e6e13961807b22e66a3f7";

export default node;
